module.exports = __webpack_public_path__ + "static/media/brain.e8f877c8.svg";